<template>
  <layout-bottom-sheet ref="bottomSheet" height="55" bottomSheetClass="confirm-bonus">
    <template v-slot:header>
        <span class="title">
          {{ title }}
        </span>
    </template>

    <slot />

    <template v-slot:footer>
      <button-base type="gray" @click="close">
        {{ cancelButton }}
      </button-base>
      <button-base type="primary" :is-disabled="bonusesUpdating" @click="emit('confirm')">
        {{ confirmButton }}
      </button-base>
    </template>
  </layout-bottom-sheet>
</template>

<script setup lang="ts">
  import type { IBottomSheetComponent } from '@skeleton/core/types';

  defineProps<{
    title?: string;
    confirmButton?: string;
    cancelButton?: string;
    bonusesUpdating?: boolean;
  }>();

  const emit = defineEmits(['closeModal', 'confirm']);

  const bottomSheet = ref<Maybe<IBottomSheetComponent>>();

  const close = (): void => {
    bottomSheet.value!.close();
  };

  const open = async (): void => {
    await bottomSheet.value!.open();
  };

  defineExpose({
    open,
    close,
  });
</script>
